import { render, staticRenderFns } from "./ui-datetime.vue?vue&type=template&id=446854f0&scoped=true"
import script from "./ui-datetime.vue?vue&type=script&lang=js"
export * from "./ui-datetime.vue?vue&type=script&lang=js"
import style0 from "./ui-datetime.vue?vue&type=style&index=0&id=446854f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446854f0",
  null
  
)

export default component.exports